import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { ISymptomeObj } from '../../dateneingabe-frageboge/questionnaire.model';

@Component({
    selector: 'rating-graph',
    templateUrl: "./rating-graph.component.html",
    styleUrls: ["./rating-graph.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class RatingGraphComponent implements OnInit {
    @Input() symptome: ISymptomeObj;
    @Input() showFreeText: boolean = false;
    @Input() type: 'PONGSLIDER' | 'Symptome' | 'Nebenwirkungen' = null;

    @Output() onShowFreeText: EventEmitter<any> = new EventEmitter();

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

    getSymptomesBG() {
            if (this.symptome.after.value < this.symptome.before.value) {
                return this.type == 'PONGSLIDER' ? "#C83232" : "#1EAB50";
            }
            else if (this.symptome.after.value > this.symptome.before.value) {
                return this.type == 'PONGSLIDER' ? "#1EAB50" : "#C83232";
            }
            else {
                return "#6E6E6E";
            }
    }

    getLowerValue() {
        return Math.min(this.symptome.before.value, this.symptome.after.value);
    }

    getIsLowerValue() {
        return this.symptome.after.value < this.symptome.before.value;
    }

    getLowerValueLeft() {
        let value = this.getLowerValue();
        value = this.getNewLeftValue(value);
        return value * 10;
    }

    getUpperValue() {
        return Math.max(this.symptome.before.value, this.symptome.after.value);
    }

    getIsUpperValue() {
        return this.symptome.after.value > this.symptome.before.value;
    }

    getUpperValueLeft() {
        let value = this.getUpperValue();
        value = this.getNewLeftValue(value);
        return value * 10;
    }

    getIsEqualValue() {
        return this.symptome.after.value == this.symptome.before.value;
    }

    getNewLeftValue(value) {
        if (this.type == 'PONGSLIDER') {
            value = value + 5;
        }
        return value;
    }

    fnShowFreeText() {
        this.onShowFreeText.emit()
    }

}
